function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import { Flex } from "sprout-ui-primitives";
import { LocalOfferOutlined as BaseLocalOfferOutlined } from "sprout-ui-icons";
import styled from "styled-components";
import { colorMap } from "@sprout/client-lib/dist/labels_next";
import { usePopoverDialogState } from "sprout-ui-dom/dist/PopoverDialog";
import { LabelEditTextPopoverDialog } from "@sprout/client-components/dist/PopoverDialog";
import { PopoverReference, PopoverTrigger } from "sprout-ui-dom/dist/Popover";
import { useActionRegistryGlobalHandler } from "@sprout/list-navigation";
import TopicPageHeaderH1 from "./TopicPageHeaderH1";
const LocalOfferOutlined = styled(BaseLocalOfferOutlined)`
  width: 36px;
  height: 36px;
  flex: none;
`;
const TopicPageHeaderLabel = (props)=>{
    const { label , disabled  } = props;
    const popoverDialogState = usePopoverDialogState();
    const { onOpenChange  } = popoverDialogState;
    useActionRegistryGlobalHandler("PAGE_EDIT_LABEL", useCallback(()=>{
        onOpenChange(true);
        return true;
    }, [
        onOpenChange
    ]));
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(LabelEditTextPopoverDialog, _objectSpread({
                placement: "bottom",
                label: label
            }, popoverDialogState)),
            /*#__PURE__*/ _jsx(PopoverReference, _objectSpread({}, popoverDialogState, {
                children: /*#__PURE__*/ _jsx(PopoverTrigger, _objectSpread({}, popoverDialogState, {
                    disabled: disabled,
                    children: /*#__PURE__*/ _jsx(TopicPageHeaderH1, {
                        beforeTitle: /*#__PURE__*/ _jsx(Flex, {
                            mr: label.text ? 3 : undefined,
                            children: /*#__PURE__*/ _jsx(LocalOfferOutlined, {
                                color: colorMap[label.style]
                            })
                        }),
                        title: label.text
                    })
                }))
            }))
        ]
    });
};
export default TopicPageHeaderLabel;
